import type { ReactNode } from 'react';

import styles from './Toggle.module.css';

export interface ToggleProps {
  checked: boolean;
  onChange: (next: boolean) => void;
  label?: ReactNode;
  disabled?: boolean;
  ariaLabel?: string;
}

export function Toggle({ checked, onChange, label, disabled, ariaLabel }: ToggleProps) {
  const body = (
    <span
      role="switch"
      aria-checked={checked}
      aria-label={label ? undefined : ariaLabel}
      aria-disabled={disabled || undefined}
      tabIndex={disabled ? -1 : 0}
      className={`${styles.toggle} ${checked ? styles.on : ''} ${disabled ? styles.disabled : ''}`}
      onClick={() => !disabled && onChange(!checked)}
      onKeyDown={(event) => {
        if (disabled) return;
        if (event.key === ' ' || event.key === 'Enter') {
          event.preventDefault();
          onChange(!checked);
        }
      }}
    />
  );

  if (!label) return body;

  return (
    <label className={`${styles.wrap} ${disabled ? styles.disabled : ''}`}>
      {body}
      <span className={styles.labelText}>{label}</span>
    </label>
  );
}
